import React, { useState, useEffect } from "react";
import Adminsidebar from "../components/Adminsidebar";
import Adminheader from "../components/Adminheader";
import Uppercase from "../components/Uppercase";
import * as XLSX from "xlsx";
import axios from "axios";
import { useYearContext } from "../components/YearContext";
import Swal from "sweetalert2";
import {toast} from "react-toastify";

function Admindocuments() {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const openSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const { yearSelected } = useYearContext();

  const [adminDocuments, setAdminDocuments] = useState([]);
  // useEffect(() => {
  //   fetchdocuments();
  // }, []);
useEffect(() => {
  if (yearSelected) {
    fetchdocuments();
  }
}, [yearSelected]);

  // const fetchdocuments = async () => {
  //   await axios
  //     .get(" https://api.litaxfilers.com/adminDocuments")
  //     .then((response) => {
  //       if (response.data.success) {
  //         setAdminDocuments(response.data.adminDocuments);

  //       } else {
  //         console.error(
  //           "Error fetching client documents:",
  //           response.data.message
  //         );
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching client documents:", error);
  //     });
  // };

  const fetchdocuments = async () => {
  try {
    const response = await axios.get(
      `https://api.litaxfilers.com/adminDocuments?taxyear=${yearSelected}` // pass selected tax year to backend
    );
    if (response.data.success) {
      setAdminDocuments(response.data.adminDocuments);
    } else {
      console.error("Error fetching client documents:", response.data.message);
    }
  } catch (error) {
    console.error("Error fetching client documents:", error);
  }
};


  const handleDownloaddoc = (filePath) => {
    // Replace backslashes with forward slashes in the filePath
    const formattedFilePath = filePath.replace(/\\/g, "/");
  
    // Construct the download URL based on the formatted filePath
    const downloadUrl = `https://api.litaxfilers.com/${formattedFilePath}`;
  
    // Fetch the file to ensure it's downloadable as a blob
    fetch(downloadUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch the file");
        }
        return response.blob(); // Get the file as a blob
      })
      .then((blob) => {
        // Create a temporary URL for the blob
        const blobUrl = URL.createObjectURL(blob);
  
        // Create a temporary link
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = formattedFilePath.split("/").pop(); // Set the file name
  
        // Append the link to the body
        document.body.appendChild(link);
  
        // Programmatically click on the link to trigger the download
        link.click();
  
        // Clean up by revoking the blob URL and removing the link
        URL.revokeObjectURL(blobUrl);
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error("Error downloading file:", error);
      });
  };
  
  const downloadTableAsExcel = () => {
    const ws = XLSX.utils.json_to_sheet(
      filterDocuments.map((doc) => ({
        "Document Type": doc.type,
        "Uploaded Date": doc.uploaded_on,
        "Uploaded Client": doc.uploaded_client,
        "Uploaded Employee": doc.uploaded_employee,
        Comment: doc.comments,
      }))
    );
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Documents");
    XLSX.writeFile(wb, "documents.xlsx");
  };

  //filters
  const [filters, setFilters] = useState({
    dateFrom: "",
    dateTo: "",
    document_type: "",
  });

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  // const filterDocuments = adminDocuments.filter((doc) => {
  //   const { dateFrom, dateTo, document_type } = filters;
  //   const documentDate = doc.uploaded_on
  //     ? doc.uploaded_on.substring(0, 10)
  //     : "";
  //   const fromDate = dateFrom ? dateFrom : "";
  //   const toDate = dateTo ? dateTo : new Date().toISOString().substring(0, 10);

  //   const nextYear = (parseInt(yearSelected) + 1).toString();
  //   const startDate = `${parseInt(nextYear) - 1}-09-01`;
  //   const endDate = `${nextYear}-08-31`;
  //   return (
  //     documentDate >= startDate &&
  //     documentDate <= endDate &&
  //     (dateFrom === "" || documentDate >= fromDate) &&
  //     (dateTo === "" || documentDate <= toDate) &&
  //     (document_type === "" || doc.type === document_type)
  //   );
  // });

//   const filterDocuments = adminDocuments.filter((doc) => {
//   const { dateFrom, dateTo, document_type } = filters;
//   const documentDate = doc.uploaded_on ? doc.uploaded_on.substring(0, 10) : "";

//   const fromDate = dateFrom || "";
//   const toDate = dateTo || new Date().toISOString().substring(0, 10);

//   // Tax year start and end
//   const nextYear = (parseInt(yearSelected) + 1).toString();
//   const startDate = `${parseInt(nextYear) - 1}-09-01`;
//   const endDate = `${nextYear}-08-31`;

//   return (
//     doc.taxyear === yearSelected && // filter by tax year
//     documentDate >= startDate &&
//     documentDate <= endDate &&
//     (dateFrom === "" || documentDate >= fromDate) &&
//     (dateTo === "" || documentDate <= toDate) &&
//     (document_type === "" || doc.type === document_type)
//   );
// });


const filterDocuments = adminDocuments.filter(
  (doc) => doc.taxyear?.toString() === yearSelected.toString()
);

  const reversedDocuments = filterDocuments.slice().reverse();

  //pagination
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 100;
  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const records = reversedDocuments.slice(firstIndex, lastIndex);
  const npage = Math.ceil(filterDocuments.length / recordsPerPage);
  const numbers = [...Array(npage + 1).keys()].slice(1);

  const prePage = () => {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  
  const changeCpage = (id) => {
    setCurrentPage(id);
  };
  const nextPage = () => {
    if (currentPage !== npage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleDelete = async(id) => {
    Swal.fire({
      title: "Are you sure?",
      position: "top",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      customClass: {
        popup: "swal-custom-height", // Apply custom class here
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
    try{
      const response = await axios.delete(`https://api.litaxfilers.com/deletedoc/${id}`);

      if(response.data.success){
        toast.success("Document deleted successfully");
        window.location.reload();

      }

    }catch(error){
      console.log(error);

    }

  }
});
  }


  return (
    <div>
      <Uppercase />
      <div className="invoice-grid-container">
        <Adminheader openSidebar={openSidebar} />
        <Adminsidebar
          openSidebarToggle={openSidebarToggle}
          openSidebar={openSidebar}
        />
        <main className="main-container mt-2">
          <div className="container">
          <div
  className="row mt-2"
  style={{
    fontSize: "12px", // Smaller text size
   
    marginBottom: "5px",
  }}
>
             <div
    className="col-lg-12 d-flex flex-wrap align-items-center gap-2"
    style={{ rowGap: "10px" }} // Adjust spacing between elements
  >
                <div >
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    name="dateFrom"
                    value={filters.dateFrom}
                    onChange={handleFilterChange}
                    style={{ minWidth: "150px" }}
                  />
                </div>

                <div >
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    name="dateTo"
                    value={filters.dateTo}
                    onChange={handleFilterChange}
                    style={{ minWidth: "150px" }}
                  />
                </div>
                <div >
                  <select
                    className="form-control form-control-sm"
                    name="document_type"
                    value={filters.document_type}
                    onChange={handleFilterChange}
                    style={{ minWidth: "150px" }}
                  >
                    <option value="">All Document Types</option>
                    <optgroup label="Income Forms" className="red-label">
                        <option value="W-2 - Wage and salary income">W-2 - Wage and salary income.</option>
                        <option value="W-2C - Corrected Wage and Tax Statement">W-2C - Corrected Wage and Tax Statement.</option>
                        <option value="W2-G - Certain Gambling Winnings">
                        W2-G - Certain Gambling Winnings.
                        </option>
                        <option value="1042-S - Foreign person's U.S. source income">1042-S - Foreign person's U.S. source income.</option>
                       
                      </optgroup>
                      <optgroup label="Foreign Wage Statement" className="red-label">
                        <option value="K-1  - Income from partnerships, S corporations, estates, or trusts">
                        K-1  - Income from partnerships, S corporations, estates, or trusts.
                        </option>
                        <option value="1099-INT - Interest income">
                        1099-INT - Interest income.
                        </option>
                        <option value="1099-DIV - Dividend income">
                        1099-DIV - Dividend income.
                        </option>
                        <option value="1099-B - Proceeds from Broker and Barter Exchange Transactions">
                        1099-B - Proceeds from Broker and Barter Exchange Transactions.
                        </option>
                        <option value="1099-NEC - Non-employee compensation">
                        1099-NEC - Non-employee compensation.
                        </option>
                        <option value="1099-MISC -Miscellaneous Income">
                        1099-MISC -Miscellaneous Income.
                        </option>
                        <option value="1099-G - Certain Government Payments">
                        1099-G - Certain Government Payments.
                        </option>
                        <option value="1099-R - Distributions from Pensions, Annuities, Retirement Plans, IRAs, etc">
                        1099-R - Distributions from Pensions, Annuities, Retirement Plans, IRAs, etc.
                        </option>
                        <option value="1099-K -Payment Card and Third-Party Network Transactions">
                        1099-K -Payment Card and Third-Party Network Transactions.
                        </option>
                        <option value="1095-A - Health Insurance Marketplace Statement">
                        1095-A - Health Insurance Marketplace Statement.
                        </option>
                        <option value="1099-S -Proceeds From Real Estate Transactions">
                        1099-S -Proceeds From Real Estate Transactions.
                        </option>
                        <option value="1099-SA -Distributions from Health Savings Accounts (HSAs) or Archer MSAs">
                        1099-SA -Distributions from Health Savings Accounts (HSAs) or Archer MSAs.
                        </option>
                        <option value="1099-C -Cancellation of Debt (discharged debt may be considered taxable income)">
                        1099-C -Cancellation of Debt (discharged debt may be considered taxable income).
                        </option>
                        <option value="1099-LTC - Long-Term Care and Accelerated Death Benefits">
                        1099-LTC - Long-Term Care and Accelerated Death Benefits.
                        </option>
                        <option value="1099-RRB - Railroad Retirement Benefits">
                        1099-RRB - Railroad Retirement Benefits.
                        </option>
                        <option value="1099-Q - Payments from Qualified Education Programs">
                        1099-Q - Payments from Qualified Education Programs.
                        </option>
                      </optgroup>
                      <optgroup label="Expense Forms" className="red-label">
                        <option value="1098 - Mortgage interest payments">1098 - Mortgage interest payments.</option>
                        <option value="1098-T -Tuition Statement">1098-T -Tuition Statement</option>
                        <option value="1098-E -Student Loan Interest Statement">1098-E -Student Loan Interest Statement</option>
                        <option value="1098-F -Fines, Penalties, and Other Amounts">1098-F -Fines, Penalties, and Other Amounts</option>
                        <option value="1098-C -Contributions of Motor Vehicles, Boats, and Airplanes">1098-C -Contributions of Motor Vehicles, Boats, and Airplanes</option>
                        <option value="Foreign Home Interest Certificate/Statement From Bank">Foreign Home Interest Certificate/Statement From Bank</option>
                       
                      </optgroup>
                      <optgroup label="Others" className="red-label">
                        <option value="Tax Organizer">Tax Organizer</option>
                        <option value="Prior Year Tax Return Copy">Prior Year Tax Return Copy</option>
                        <option value="Tax Summary">Tax Summary</option>
                        <option value="Client Copy">Client Copy</option>
                        <option value="IDS">IDS</option>
                        <option value="Final Draft">Final Draft</option>
                        <option value="Paper Filing Instructions">Paper Filing Instructions</option>
                        <option value="Other Documents">Other Documents</option>                       
                      </optgroup>
                  </select>
                </div>
              </div>
            </div>


         <div
  className="table-container"
  style={{
    height: "calc(89vh - 150px)", // Adjust the 150px based on your header/pagination height
   
    border: "1px solid #ccc",
  }}
>
            <div className="table-responsive tablediv">
            <table
      className="table table-hover table-bordered"
      style={{
        fontSize: "12px", // Smaller font size
        lineHeight: "1.2", // Reduce line height for compact view
      }}
    >
                <thead className="table-primary">
                  <tr>
                    <th style={{ padding: "5px" }}>S.No</th>
                    <th style={{ padding: "5px" }}>Document Type</th>
                    <th style={{ padding: "5px" }}>Uploaded On</th>
                    <th style={{ padding: "5px" }}>Uploaded Client</th>
                    {/* <th style={{ padding: "5px" }}>Uploaded Employee</th> */}
                    <th style={{ padding: "5px" }}>Uploaded Admin</th>
                    <th style={{ padding: "5px" }}>Comments</th>
                    <th style={{ padding: "5px" }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {records.map((document, index) => (
                    <tr key={index}>
                    <td style={{ padding: "5px" }}>
                {filterDocuments.length -
                  ((currentPage - 1) * recordsPerPage +
                  index)}
              </td>
                      <td>{document.type}</td>
                      <td>{document.uploaded_on}</td>
                      <td>{document.uploaded_client}</td>
                      {/* <td>{document.uploaded_employee}</td> */}
                      <td>{document.uploaded_admin}</td>
                      <td>{document.comments}</td>
                      <td className="d-flex gap-2">
                        <button
                          className="btn btn-sm btn-primary"
                          title="Download PDF"
                          onClick={() => {
                            
                            handleDownloaddoc(document.filePath.trim());
                          }}
                        >
                          Download
                        </button>
                        <button className="btn btn-sm btn-danger" onClick={() => handleDelete(document.id)}>Delete</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            </div>

            <nav className="mt-2">
            <ul
    className="pagination"
    style={{
      fontSize: "10px", // Reduce font size
      padding: "0", // Remove unnecessary padding
    }}
  >
                <li className="page-item">
                  <a href="#" className="page-link" onClick={prePage}  style={{
          padding: "2px 5px", // Adjust padding for smaller height
          height: "auto", // Allow height to adjust with padding
          fontSize: "12px",
        }} >
                    Prev
                  </a>
                </li>
                {numbers.map((n, i) => {
                  return (
                    <li
                      className={`page-item ${
                        currentPage === n ? "active" : ""
                      }`}
                      key={i}
                    >
                      <a
                        href="#"
                        className="page-link"
                        onClick={() => changeCpage(n)}
                        style={{
              padding: "2px 5px", // Reduce padding
              height: "auto", // Consistent height
              fontSize: "12px",
            }}
                      >
                        {n}
                      </a>
                    </li>
                  );
                })}
                <li className="page-item">
                  <a href="#" className="page-link" onClick={nextPage}
                   style={{
          padding: "2px 5px", // Same padding as above
          height: "auto", // Adjust height
          fontSize: "12px",
        }}>
                    Next
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </main>
      </div>
    </div>
  );
}

export default Admindocuments;

